import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material';
import { ButtonSpinnerSlot } from '../ui/ButtonSpinner';
import useDemoActionGate from '../hooks/useDemoActionGate';
import DemoLockedDialog from '../ui/DemoLockedDialog';

const FormDialog = ({ open, handleClose, data, onChange, handleFormSubmit, loading }) => {
    const { guardAction, lockedDialogOpen, setLockedDialogOpen } = useDemoActionGate();
    const onSubmit = () => {
        if (!guardAction('action.training.question.save')) return;
        handleFormSubmit();
    };
    return (
        <>
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth maxWidth="md">
            <DialogTitle id="form-dialog-title">{data.questionId ? 'Update Question' : 'Add New Question'}</DialogTitle>
            <DialogContent dividers sx={{ overflowY: 'auto' }}>
                <TextField
                    margin="dense"
                    id="question"
                    label="Question"
                    type="text"
                    fullWidth
                    value={data.question}
                    onChange={onChange}
                />
                <TextField
                    margin="dense"
                    id="explanation"
                    label="Explanation"
                    type="text"
                    fullWidth
                    value={data.explanation}
                    onChange={onChange}
                />
                <TextField
                    margin="dense"
                    id="hint"
                    label="Hint"
                    type="text"
                    fullWidth
                    value={data.hint}
                    onChange={onChange}
                />
                <TextField
                    margin="dense"
                    id="correctAnswer"
                    label="Correct Answer"
                    type="text"
                    fullWidth
                    value={data.correctAnswer}
                    onChange={onChange}
                />
                <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                    {data.answer && data.answer.map((answer, index) => (
                        !answer.is_correct && (
                            <TextField
                                key={answer.answer_id}
                                margin="dense"
                                id={`incorrectAnswer${index}`}
                                label={`Incorrect Answer ${index + 1}`}
                                type="text"
                                fullWidth
                                value={answer.answer}
                                onChange={(e) => onChange(e, index)}
                            />
                        )
                    ))}
                </div>
                <TextField
                    margin="dense"
                    id="mimeType"
                    label="Mime Type"
                    type="text"
                    fullWidth
                    value={data.mimeType}
                    onChange={onChange}
                />
                {data.asset && (
                    <div style={{ textAlign: 'center', margin: '20px 0' }}>
                        <img src={data.asset} alt="Question Asset" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                    </div>
                )}
                <TextField
                    margin="dense"
                    id="keywords"
                    label="Keywords"
                    type="text"
                    fullWidth
                    value={data.keywords}
                    onChange={onChange}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={onSubmit} color="primary" disabled={loading}>
                    {loading ? <ButtonSpinnerSlot size={24} /> : 'Submit'}
                </Button>
            </DialogActions>
        </Dialog>
        <DemoLockedDialog open={lockedDialogOpen} onClose={() => setLockedDialogOpen(false)} />
        </>
    );
};

export default FormDialog;
